<template>  
  <v-container justify-center>
    <v-form
    ref="formHojaRutaCompany"
    v-model="valid"
    lazy-validation>
      <v-layout>
        <v-flex xs6 md5>
          <v-combobox
            v-model="selectedProfile"
            :items="profiles"
            label="Perfil"
            :rules="[v => !!v || 'Seleccione un perfil']"
            required
          ></v-combobox>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6 md5>
          <v-combobox
            v-model="selectedType"
            :items="types"
            label="Tipo"
            :rules="[v => !!v || 'Seleccione un tipo']"
            required
          ></v-combobox>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6 md5>
          <v-combobox
            v-model="selectedExam"
            :items="this.$store.state.procedures"
            item-value="id"
            item-text="name"
            label="Examen"
            :rules="[v => !!v || 'Seleccione un examen']"
            required
          ></v-combobox>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm6 offset-sm4>
          <div>
            <v-btn :disabled="!valid"
                    @click="addData"  large color="secundary">Agregar</v-btn>
          </div>
        </v-flex>
      </v-layout>
      <br>
      <br>
      <v-layout>
        <v-flex xs12 sm10>
          <v-data-table
          :headers="headers"
          :items="exams"
          class="elevation-1"
          no-data-text="No hay examenes en esta hoja de ruta"
          hide-actions>
          <template v-slot:items="props">
            <td>{{ props.item.profile }}</td>
            <td>{{ props.item.type }}</td>
            <td style="width:40%">{{ props.item.examName }}</td>
            <td>
              <v-flex xs10 sm8 md5>
                <v-text-field
                  label="Precio"
                  v-model="props.item.price"
                  box>
                </v-text-field>
              </v-flex>
            </td>
            <td>            
              <v-tooltip top >
                <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                  <v-icon dark>delete</v-icon>
                </v-btn>
              <span>Eliminar</span>
              </v-tooltip>
          </td>
          </template>
        </v-data-table>
        </v-flex>
      </v-layout>
      <br>    
      <v-layout>
        <v-flex xs12 sm6 offset-sm4>
          <div>
            <v-btn
                    @click="saveData"  large color="primary">Guardar</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
  import RouteSheet from '../../../model/RouteSheet'

  export default {
    props: ['company'],
    data () {
      return {
        valid: true,
        selectedProfile: '',
        selectedType: '',
        selectedExam: '',        
        profiles: ['ADMINISTRATIVO', 'OPERATIVO'],
        types: ['PRE', 'INI', 'OCU', 'REU', 'ESP', 'RET', 'REI'],
        exams: [],
        headers: [
          { text: 'Perfil', value: 'profile' },
          { text: 'Tipo', value: 'type' },
          { text: 'Examen', value: 'examName' },
          { text: 'Precio', value: 'price' },
          { text: 'Acciones', value: 'actions'}
        ],
        routeSheet: new RouteSheet()       
      }
    },

    methods: {      
      addData() {        
        if (this.$refs.formHojaRutaCompany.validate()) {
          for (let i=0; i<this.exams.length; i++) {
            if (this.exams[i].procedure.name === this.selectedExam.name &&
                this.exams[i].profile === this.selectedProfile &&
                this.exams[i].type === this.selectedType) {
              alert("Ya se ha agregado este examen");
              return;
            }
          }
          var price = 0.00;
          this.routeSheet = new RouteSheet();
          this.routeSheet.profile = this.selectedProfile;
          this.routeSheet.type = this.selectedType;
          this.routeSheet.examName = this.selectedExam.name;
          this.routeSheet.company = this.company;
          this.routeSheet.price = price;
          this.routeSheet.procedure = this.selectedExam;
          this.exams.push(this.routeSheet);
          this.cleanInputDataExams();
        }
      },
      cleanInputDataExams() {        
        this.selectedProfile = '';
        this.selectedType = '';
        this.selectedExam = '';
        this.$refs.formHojaRutaCompany.resetValidation()
      },
      saveData() {        
        this.$store.dispatch('deleteByCompany', this.company.id).then(response => {
          for (let i=0; i<this.exams.length; i++) {
              this.exams[i].id = "";
              this.$store.dispatch('addRouteSheet', this.exams[i]).then(response => {
              })          
          }
          alert("Hojas de ruta guardadas con exito");
        })
      },
      deleteItem (item) {        
        let index = this.exams.indexOf(item)              
        confirm('Está seguro de que quiere eliminar el registro?') && this.exams.splice(index, 1)
      }
    },
    created() {
      this.$store.dispatch('findRouteSheetByCompany', this.company.id).then(response => {
        for (let i=0; i<response.data.length; i++) {
          this.routeSheet = new RouteSheet();          
          this.routeSheet = response.data[i];
          this.routeSheet.examName = this.routeSheet.procedure.name;
          this.exams.push(this.routeSheet);
        }        
      })
    },
    beforeCreate(){      
      this.$store.dispatch('getProcedures').then(response => {
      })      
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/company/hojaDeRuta/HojaDeRuta.vue